import { render } from "./App.vue?vue&type=template&id=7d76dd92&class=no-scroll&style=background%3A%20%23f4ece0%3B"
const script = {}

import "./App.vue?vue&type=style&index=0&id=7d76dd92&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__